import { render, staticRenderFns } from "./recharge-table.vue?vue&type=template&id=ab5fe5d2&scoped=true"
import script from "./recharge-table.vue?vue&type=script&lang=js"
export * from "./recharge-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5fe5d2",
  null
  
)

export default component.exports